/* eslint-disable */

import axios from 'axios';

const zlib = require('zlib');
const util = require('util');

const gunzip = util.promisify(zlib.gunzip);

axios.defaults.baseURL = process.env.VUE_APP_TEAMIO_API_URL

export default {
  namespaced: true,
  state: {
    data: [],
    huddleDetails: [],
    proceduralTrackingData: [],
    newPatientReportData: null,
    newPatientReportComparisonData: null
  },

  mutations: {
    setData(state, payload) {
        state.data = payload;
    },

    setHuddleDetails(state, payload) {
      state.huddleDetails = payload;
    },

    setProceduralTrackingData(state, payload) {
      state.proceduralTrackingData = payload;
    },

    setNewPatientReportData(state, payload) {
      state.newPatientReportData = payload;
    },

    setNewPatientReportComparisonData(state, payload) {
      state.newPatientReportComparisonData = payload;
    },

    clearNewPatientReportData(state) {
      state.newPatientReportData = null;
      state.newPatientReportComparisonData = null;
    }
  },

  actions: {
    async getHuddleData({commit, dispatch}, payload) {
        try {
            dispatch('alert/setLoading', true, {root: true});
            let response = await axios.post(`/get-huddle-data`, payload, { crossdomain: true });
            commit('setData', response);
            dispatch('alert/setLoading', false, {root: true});
            dispatch('alert/setLoaded', true, {root: true});
            return response;
        }
        catch(err) {
            console.log('Error Getting Huddle Data:', err);
            dispatch('alert/setErrored', true, {root: true});
            dispatch('alert/setMessage', err, {root: true});
        }
    },

    async getHygieneOpportunities({commit, dispatch}, payload) {
      try {
          dispatch('alert/setLoading2', true, {root: true});
          let response = await axios.post(`/get-hygiene-opportunities`, payload, { crossdomain: true });          
          commit('setData', response);
          dispatch('alert/setLoading2', false, {root: true});
          dispatch('alert/setLoaded2', true, {root: true});
          if((response.data && response.data.length === 0) || (response.data && response.data.length > 0 && (response.data[0].length === 0 && response.data[1].length === 0) )) {
            dispatch('alert/setErrored2', true, {root: true});
            dispatch('alert/setMessage2', 'No data found', {root: true});
          }
          return response;
      }
      catch(err) {
          console.log('Error Getting Hygiene Opportunities:', err);
          dispatch('alert/setErrored2', true, {root: true});
          dispatch('alert/setMessage2', err, {root: true});
      }
  },

    async getHuddleDetailsData({commit, dispatch}, payload) {
      try {
          dispatch('alert/setLoading2', true, {root: true});
          let response = await axios.post(`/get-huddle-details-data`, payload, { crossdomain: true });
          commit('setHuddleDetails', response);
          dispatch('alert/setLoading2', false, {root: true});
          dispatch('alert/setLoaded2', true, {root: true});
          return response;
      }
      catch(err) {
          console.log('Error Getting Huddle Data:', err);          
          throw err;
      }
    },

    async getHuddleAdvancedTxPlannedData({ commit, dispatch }, payload) {
      try {
        dispatch('alert/setLoading2', true, { root: true });
        let response = await axios.post(`/get-advanced-txplanned-data`, payload, { crossdomain: true });

        console.log('Raw response:', response); // Log the entire response
        
        commit('setHuddleDetails', response);
        dispatch('alert/setLoading2', false, { root: true });
        dispatch('alert/setLoaded2', true, { root: true });

        return response;
      }
      catch (err) {
        console.log('Error Getting Advanced Tx Planned Data:', err);
        throw err;
      }
    },

    async getTxPriorities({commit, dispatch}, payload) {
      try {
          dispatch('alert/setLoading2', true, {root: true});
          let response = await axios.post(`/get-tx-priorities`, payload, { crossdomain: true });
          dispatch('alert/setLoading2', false, {root: true});
          dispatch('alert/setLoaded2', true, {root: true});
          if(response.status === 200)
            return response.data;
      }
      catch(err) {
          console.log('Error Getting Advanced Tx Priorities:', err);          
          throw err;
      }
    },

    async getHuddleProceduralTrackingData({commit, dispatch}, payload) {
      try {
          dispatch('alert/setLoading2', true, {root: true});
          let response = await axios.post(`/get-procedural-tracking-data`, payload, { crossdomain: true });
          commit('setProceduralTrackingData', response);
          dispatch('alert/setLoading2', false, {root: true});
          dispatch('alert/setLoaded2', true, {root: true});
          return response;
      }
      catch(err) {          
          throw err;
      }
    },

    async getGoals({commit, dispatch}, payload) {
      try {
          dispatch('alert/setLoading2', true, {root: true});
          let response = await axios.post(`/get-goals`, payload, { crossdomain: true });          
          dispatch('alert/setLoading2', false, {root: true});
          dispatch('alert/setLoaded2', true, {root: true});          
          return response;
      }
      catch(err) {
          console.log('Error getting goals:', err);
          throw err;
      }
    },

    async saveGoals({commit, dispatch}, payload) {
      try {
          dispatch('alert/setLoading2', true, {root: true});
          let response = await axios.post(`/save-goals`, payload, { crossdomain: true });          
          dispatch('alert/setLoading2', false, {root: true});
          dispatch('alert/setLoaded2', true, {root: true});          
          return response;
      }
      catch(err) {                    
          throw err;
      }
    },

    /**
     * Get New Patient Report Data
     * @param {Object} payload - { siteID, fromDate, toDate, filters }
     * @param {Object} payload.filters - Optional filters { provNum, initialVisitCodes, initialAptStatus, nextAptStatus, nextAptProcCodes }
     */
    async getNewPatientReportData({commit, dispatch}, payload) {
      try {
          // Note: Loading state is handled by component's b-overlay, not here
          // Following getHuddleAdvancedTxPlannedData pattern - returns compressed response
          let response = await axios.post(`/get-new-patient-report-data`, payload, { crossdomain: true });
          if(response.status === 200) {
            commit('setNewPatientReportData', response);
          }
          return response;
      }
      catch(err) {
          console.log('Error Getting New Patient Report Data:', err);
          throw err;
      }
    },

    /**
     * Get New Patient Report Comparison Data (for timeframe comparison pie chart)
     * @param {Object} payload - { siteID, fromDate, toDate }
     */
    async getNewPatientReportComparisonData({commit, dispatch}, payload) {
      try {
          let response = await axios.post(`/get-new-patient-report-comparison-data`, payload, { crossdomain: true });
          if(response.status === 200) {
            commit('setNewPatientReportComparisonData', response.data);
          }
          return response.data;
      }
      catch(err) {
          console.log('Error Getting New Patient Report Comparison Data:', err);
          throw err;
      }
    },

    /**
     * Get Production Trends Data (for Advanced Production Trends panel)
     * @param {Object} payload - { siteID, dateFrom, dateTo }
     */
    async getProductionTrendsData({commit, dispatch}, payload) {
      try {
          let response = await axios.post(`/get-production-trends-data`, payload, { crossdomain: true });
          return response;
      }
      catch(err) {
          console.log('Error Getting Production Trends Data:', err);
          throw err;
      }
    },

    /**
     * Clear new patient report data from store
     */
    clearNewPatientReportData({commit}) {
      commit('clearNewPatientReportData');
    }
  }
};
